<template>
    <div>
        <v-row justify="center">
            <v-col class="pa-0 ma-0 col-1">
                <!--                <v-btn-->
                <!--                        v-show="aMultipleSelectedItems.length > 1"-->
                <!--                        @click="addMultiple(true)"-->
                <!--                        fab-->
                <!--                        small-->
                <!--                        elevation="6"-->
                <!--                        style="-->
                <!--                            z-index: 6;-->
                <!--                            position: fixed;-->
                <!--                            top: 24rem;-->
                <!--                        "-->
                <!--                        class="ml-4"-->
                <!--                >-->
                <!--                    <v-icon color="blue">-->
                <!--                        mdi-decimal-increase-->
                <!--                    </v-icon>-->
                <!--                </v-btn>-->

                <v-btn
                        v-show="aMultipleSelectedItems.length > 0"
                        @click="addMultiple(false)"
                        fab
                        small
                        elevation="6"
                        style="
                            z-index: 6;
                            position: fixed;
                            top: 27rem;
                        "
                        class="ml-4"
                >
                    <v-icon color="blue">
                        mdi-table-arrow-right
                    </v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="pb-0 pt-0">
                <v-card
                        class="mt-2"
                        outlined
                        elevation="2"
                >
                    <v-card-title class="pb-0">Tabela de Preços</v-card-title>
                    <v-card-text>
                        <form>
                            <!--                        <form v-on:submit.prevent="getFromApi()">-->
                            <v-row class="pb-0">
                                <v-col class="col-md-3 pb-0">
                                    <v-text-field
                                            v-model="nome"
                                            class="mb-0 mb-0"
                                            autocomplete="off"
                                            label="Nome"
                                            placeholder="Nome da nova tabela de preços"
                                            required
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="pr-0 pt-0" v-show="showAddItems">
                <v-card
                        class="mt-1 mr-1"
                        outlined
                        elevation="2"
                >
                    <v-card-title class="pb-0">
                        Mercadorias do cadastro
                    </v-card-title>

                    <v-card-text>
                        <Mercadoria v-on:emitItem="addItemFromMercView"
                                    v-on:emitSelectedItems="getSelectedItemsFromMercView"
                                    is-used-into-another-view="tabela-preco"
                        >
                        </Mercadoria>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col class="pt-0" v-bind:class="{'pl-0': showAddItems}">
                <v-card
                        class="mt-1"
                        outlined
                        elevation="2"
                >
                    <v-card-title class="pb-0">
                        Itens da tabela de preços
                        <v-col class="col-4 pb-0">
                            <v-btn icon color="blue" @click="showAddItems = !showAddItems">
                                <v-icon>mdi-playlist-plus</v-icon>
                            </v-btn>
                            <!--                            <v-btn icon color="blue" @click="showAddItem = !showAddItem">-->
                            <!--                                <v-icon>mdi-plus</v-icon>-->
                            <!--                            </v-btn>-->
                        </v-col>
                    </v-card-title>
                    <!--                    <v-card-text v-if="showAddItem">-->
                    <!--                        <v-form v-on:submit.prevent="addItem({-->
                    <!--                                        id: null,-->
                    <!--                                        mercadoria_id: frmAddItems.mercadoria.id,-->
                    <!--                                        mercadoria_descricao: frmAddItems.mercadoria.descricao,-->
                    <!--                                        preco: frmAddItems.preco-->
                    <!--                                })"-->
                    <!--                        >-->
                    <!--                            <v-row>-->
                    <!--                                <v-col-->
                    <!--                                        cols="12"-->
                    <!--                                        md="4"-->
                    <!--                                        class="pt-0"-->
                    <!--                                >-->
                    <!--                                    <v-autocomplete-->
                    <!--                                            v-model="frmAddItems.mercadoria"-->
                    <!--                                            label="Mercadoria"-->
                    <!--                                            placeholder="Código ou descrição"-->
                    <!--                                            :items="autoCompl.items"-->
                    <!--                                            item-value="id"-->
                    <!--                                            item-text="descricao"-->
                    <!--                                            :loading="autoCompl.loading"-->
                    <!--                                            :search-input.sync="autComplSearch"-->
                    <!--                                            :auto-select-first="true"-->
                    <!--                                            no-filter-->
                    <!--                                            return-object-->
                    <!--                                    ></v-autocomplete>-->
                    <!--                                </v-col>-->

                    <!--                                <v-col>-->
                    <!--                                    <v-btn type="submit" icon color="primary">-->
                    <!--                                        <v-icon small>mdi-arrow-down</v-icon>-->
                    <!--                                    </v-btn>-->
                    <!--                                </v-col>-->

                    <!--                            </v-row>-->
                    <!--                        </v-form>-->
                    <!--                    </v-card-text>-->

                    <v-card-text>

                        <v-data-table
                                :headers="dtTblPrecoItens.headers"
                                :items="dtTblPrecoItens.items"
                                item-key="id"
                                class="elevation-1"
                                :loading="dtTblPrecoItens.loading"
                                loading-text="Carregando..."
                                no-data-text="Nenhum registro encontrado"
                                dense
                                show-current-page="true"
                                :footer-props="{
                                  showFirstLastPage: true,
                                  showCurrentPage: true,
                                  'items-per-page-options': [5, 10, 30, 70, 100],
                                }"
                                :items-per-page="30"
                        >
                            <template v-slot:item.actions="{ item }">
                                <v-icon
                                        small
                                        @click="deleteItem(item)"
                                        color="error"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>

                            <template v-slot:item.destaque="{ item }">
                                <v-checkbox
                                        v-model="item.destaque"
                                        dense
                                        class="mt-0"
                                        hide-details
                                        color="blue"
                                ></v-checkbox>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!--        <v-divider></v-divider>-->

        <v-btn
                class="ma-2"
                color="secondary"
                to="/tabelas-precos"
                :disabled="btnSalvarLoading"
        >
            Cancelar
        </v-btn>
        <v-btn
                class="ma-2"
                color="primary"
                @click="save"
                :disabled="btnSalvarLoading || dtTblPrecoItens.loading"
                :loading="btnSalvarLoading"
        >
            Salvar
        </v-btn>

        <v-dialog
                v-model="alertDialog"
                max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    <span class="orange--text">Atenção</span>
                </v-card-title>

                <v-card-text>
                    {{alertDialogText}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="primary darken-1"
                            text
                            @click="alertDialog = false"
                    >
                        Ok, entendi
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="priceDialog.show"
                max-width="220"
        >
            <v-card>
                <v-card-text class="pt-4 pb-0">
                    <div class="title">
                        {{priceDialog.mercadoria_codigo}} - {{priceDialog.mercadoria_descricao}}
                    </div>
                    <v-divider></v-divider>
                </v-card-text>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-form v-on:submit.prevent="addItem({
                                        id: null,
                                        mercadoria_id: priceDialog.mercadoria_id,
                                        mercadoria_descricao: priceDialog.mercadoria_descricao,
                                        departamento_id: priceDialog.departamento_id,
                                        departamento: priceDialog.departamento,
                                        preco: priceDialog.preco
                                }, true)">
                                <v-text-field
                                        v-model="priceDialog.preco"
                                        type="number" min="0.00" max="10000.00" step="0.01"
                                        prefix="R$"
                                        label="Preço"
                                        hint="Digite o valor e pressione 'Enter'"
                                        persistent-hint
                                        :autofocus=true
                                ></v-text-field>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>


</template>

<script>
    import {isInt} from '../../libs/utils';
    import Mercadoria from '../Mercadoria';

    export default {
        components: {
            Mercadoria
        },
        data: () => ({
            tabelaPrecoId: "",
            nome: "",

            dtTblPrecoItens: {
                items: [],
                removedItems: [],
                totalItems: 0,
                loading: false,
                options: {},
                headers: [
                    {
                        text: 'Ações',
                        value: 'actions',
                        sortable: false,
                        width: '6%',
                    },
                  {
                    text: 'Código',
                    align: 'start',
                    sortable: true,
                    value: 'codigo',
                    width: '10%',
                  },
                    {
                        text: 'Mercadoria',
                        align: 'start',
                        sortable: true,
                        value: 'mercadoria_descricao',
                        width: '20%',
                    },
                    {
                        text: 'destacar',
                        sortable: true,
                        value: 'destaque',
                        width: '4%',
                    },
                ],
            },

            showAddItem: false,
            showAddItems: true,
            aMultipleSelectedItems: [],
            frmAddItems: {
                mercadoria: '',
                preco: ''
            },

            autoCompl: {
                loading: false,
                items: [],
            },
            autoComplItems: [],
            autComplSearch: null,

            priceDialog: {
                show: false,
                preco: '',
                mercadoria_id: '',
                mercadoria_codigo: '',
                mercadoria_descricao: '',
                departamento_id: '',
                departamento: '',
            },
            alertDialog: false,
            alertDialogText: "",
            filters: {
                departamento: '',
                quickSearch: '',
            },

            // btn loading
            btnSalvarLoading: null,

            //select de departamentos
            departamentos: [{text: '', value: ''}],

            editedIndex: -1,
            editedItem: {
                codigo: '',
                descricao: '',
            },
            defaultItem: {
                codigo: '',
                descricao: '',
            },
        }),

        created() {
            this.tabelaPrecoId = this.$route.params.tabelaPrecoId;
            this.getFromApi();
        },

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'Novo Item' : 'Edição do Item'
            },
        },

        watch: {
            autComplSearch(val) {
                if (isInt(val) || val.length >= 3) {
                    this.autoCompl.loading = true;

                    let params = {
                        filters: {quickSearch: val},
                        page: 1,
                        itemsPerPage: 10,
                    };

                    axios.get(this.$store.getters.getUsrEndpoint + '/mercadorias', {params: params})
                        .then((response) => {
                                this.autoCompl.items = response.data.items;
                                this.autoCompl.loading = false
                            }, (error) => {
                                console.log(error);
                            }
                        )
                        .catch(error => {
                            console.log(error)
                            // this.errored = true
                        })
                        .finally(() => this.autoCompl.loading = false)
                    ;
                }
            },

            dialog(val) {
                val || this.close()
            },

            options: {
                handler() {
                    this.getFromApi();
                },
                deep: true,
            }

        },

        methods: {
            addItemFromMercView(obj) {
                if (obj.askPrice) {
                    this.priceDialog.preco = '';
                    this.priceDialog.show = true;
                    this.priceDialog.askPrice = true;

                    this.priceDialog.mercadoria_id = obj.item.id;
                    this.priceDialog.mercadoria_codigo = obj.item.codigo;
                    this.priceDialog.mercadoria_descricao = obj.item.descricao;
                    this.priceDialog.departamento_id = obj.item.departamento_id;
                    this.priceDialog.departamento = obj.item.departamento;
                } else {
                    let itemAux = {};
                    itemAux.askPrice = false;

                    itemAux.mercadoria_id = obj.item.id;
                    itemAux.mercadoria_codigo = obj.item.codigo;
                    itemAux.mercadoria_descricao = obj.item.descricao;
                    itemAux.departamento_id = obj.item.departamento_id;
                    itemAux.departamento = obj.item.departamento;
                    this.addItem(itemAux);
                }
            },

            getSelectedItemsFromMercView(arrObj) {
                this.aMultipleSelectedItems = [];

                arrObj = JSON.parse(JSON.stringify(arrObj));
                if (arrObj.length > 0) {
                    this.aMultipleSelectedItems = arrObj;
                }
                // for (const i in arrObj) {
                //     this.addItem(arrObj[i]);
                // }
            },

            addMultiple(askPrice, goToNext) {
                goToNext = typeof goToNext != "undefined" ? goToNext : false;

                if (goToNext) {//remove o primeiro item(acabou de ser inserido)
                    this.aMultipleSelectedItems.shift();
                }

                if (this.aMultipleSelectedItems.length) {
                    if (askPrice) {//a janela de confirmação de preça chama de novo o addMultiple
                        this.addItemFromMercView({askPrice: true, item: this.aMultipleSelectedItems[0]});
                    } else {//add todos de uma vez
                        for (const i in this.aMultipleSelectedItems) {
                            this.addItemFromMercView({askPrice: false, item: this.aMultipleSelectedItems[i]});
                        }
                        // this.aMultipleSelectedItems = [];
                    }
                }
            },

            addItem(item, calledFromDialog) {
                calledFromDialog = typeof calledFromDialog != "undefined" ? calledFromDialog : false;

                let iNewLength = 0;
                let isUpdate = false;

                this.priceDialog.show = false;

                if (item.mercadoria_id) {
                    for (var i in this.dtTblPrecoItens.items) {
                        if (item.mercadoria_id == this.dtTblPrecoItens.items[i].mercadoria_id) {
                            if (item.preco > 0) {
                                this.dtTblPrecoItens.items[i].preco = item.preco;
                                isUpdate = true;
                            } else {
                                return false;
                            }
                        }
                    }

                    //recupera item removido
                    for (var i in this.dtTblPrecoItens.removedItems) {
                        if (item.mercadoria_id == this.dtTblPrecoItens.removedItems[i].mercadoria_id) {
                            this.dtTblPrecoItens.removedItems[i].preco = item.preco;
                            item = this.dtTblPrecoItens.removedItems[i];
                            this.dtTblPrecoItens.removedItems.splice(i, 1);
                            break;
                        }
                    }

                    if (!isUpdate) {
                        iNewLength = this.dtTblPrecoItens.items.push(item);
                    }

                    if (iNewLength) {
                        this.dtTblPrecoItens.totalItems = iNewLength;
                    }

                    if (calledFromDialog) {
                        this.addMultiple(true, true);
                    }
                }

                this.frmAddItems.mercadoria = '';
                this.frmAddItems.preco = '';
            },

            getFromApi() {
                this.dtTblPrecoItens.loading = true;

                const {sortBy, sortDesc, page, itemsPerPage} = this.dtTblPrecoItens.options;

                let params = {
                    filters: this.filters,
                    sortBy: sortBy,
                    sortDesc: sortDesc,
                    page: page,
                    itemsPerPage: itemsPerPage,
                };

                axios.get('/tabelas-precos/' + this.tabelaPrecoId + '/itens', {params: params})
                    .then((response) => {
                            this.nome = response.data.header.nome;
                            this.dtTblPrecoItens.items = response.data.items;
                            this.dtTblPrecoItens.totalItems = response.data.totalItems;
                            this.dtTblPrecoItens.loading = false;
                        }, (error) => {
                            console.log(error);
                        }
                    )
                    .catch(error => {
                        console.log(error)
                        // this.errored = true
                    })
                    .finally(() => this.loading = false)
                ;
            },

            editItem(item) {
                this.editedIndex = this.dtTblPrecoItens.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                // this.editedItem.departamento = this.editedItem.departamento_id;
                this.dialog = true
            },

            deleteItem(item) {
                const index = this.dtTblPrecoItens.items.indexOf(item);
                this.dtTblPrecoItens.items.splice(index, 1);

                // add na lista de itens removidos
                if (item.id) {
                    this.dtTblPrecoItens.removedItems.push(item);
                }
            },

            close() {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            save() {
                // this.loading = true;
                this.btnSalvarLoading = 'loading';

                if (!this.nome.length) {
                    alert("O nome é obrigatório");

                    this.loading = false;
                    this.btnSalvarLoading = null;

                    return false;
                }

                if (!this.dtTblPrecoItens.items.length) {
                    alert("Nenhum item definido na lista");

                    this.loading = false;
                    this.btnSalvarLoading = null;

                    return false;
                }

                //faz o submit
                let axiosss;
                let data = {
                    nome: this.nome,
                    itens: this.dtTblPrecoItens.items,
                    removedItems: this.dtTblPrecoItens.removedItems,
                };

                if (this.tabelaPrecoId == 0) {
                    axiosss = axios.post(this.$store.getters.getUsrEndpoint + '/tabelas-precos', data);
                } else {
                    axiosss = axios.put('/tabelas-precos/' + this.tabelaPrecoId, data);
                }

                axiosss.then((response) => {
                    this.$router.push({path: '/tabelas-precos/'});
                }, (error) => {
                    this.alertDialog = true;
                    this.alertDialogText = "Houve um problema ao salvar o registro";
                }).catch(error => {
                    console.log(error)
                    // this.errored = true
                }).finally(() => {
                    this.loading = false;
                    this.btnSalvarLoading = null;
                });
            },
        },
    }
</script>
